/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState, useRef } from 'react'
import { signIn, useSession } from 'next-auth/react'
import { useRouter } from 'next/router'
import Autocomplete from '@mui/material/Autocomplete';
import {
  Typography,
  Box,
  TextField,
  Button,
  Grid,
  InputAdornment
} from '@mui/material';

import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import CircularProgress from '@mui/material/CircularProgress';
import OTPInputGroup from './OTPInputGroup'

import { useDispatch, useSelector } from 'react-redux'
import { getAccessToken } from '../../redux/slices/user'

const countries = [
  { code: 'AD', label: 'Andorra', phone: '376', maxlength: '9' },
  { code: 'AE', label: 'United Arab Emirates', phone: '971', maxlength: '9' },
  { code: 'AF', label: 'Afghanistan', phone: '93', maxlength: '9' },
  { code: 'AG', label: 'Antigua and Barbuda', phone: '1-268', maxlength: '7' },
  { code: 'AI', label: 'Anguilla', phone: '1-264', maxlength: '7' },
  { code: 'AL', label: 'Albania', phone: '355', maxlength: '8' },
  { code: 'AM', label: 'Armenia', phone: '374', maxlength: '8' },
  { code: 'AO', label: 'Angola', phone: '244', maxlength: '9' },
  { code: 'AQ', label: 'Antarctica', phone: '672', maxlength: '6' },
  { code: 'AR', label: 'Argentina', phone: '54', maxlength: '10' },
  { code: 'AS', label: 'American Samoa', phone: '1-684', maxlength: '7' },
  { code: 'AT', label: 'Austria', phone: '43', maxlength: '10' },
  {
    code: 'AU',
    label: 'Australia',
    phone: '61',
    suggested: true,
    maxlength: '9'
  },
  { code: 'AW', label: 'Aruba', phone: '297', maxlength: '7' },
  { code: 'AX', label: 'Alland Islands', phone: '358', maxlength: '9' },
  { code: 'AZ', label: 'Azerbaijan', phone: '994', maxlength: '9' },
  { code: 'BA', label: 'Bosnia and Herzegovina', phone: '387', maxlength: '8' },
  { code: 'BB', label: 'Barbados', phone: '1-246', maxlength: '7' },
  { code: 'BD', label: 'Bangladesh', phone: '880', maxlength: '10' },
  { code: 'BE', label: 'Belgium', phone: '32', maxlength: '9' },
  { code: 'BF', label: 'Burkina Faso', phone: '226', maxlength: '8' },
  // Add more countries here in alphabetical order
  { code: 'BG', label: 'Bulgaria', phone: '359', maxlength: '9' },
  { code: 'BH', label: 'Bahrain', phone: '973', maxlength: '8' },
  { code: 'BI', label: 'Burundi', phone: '257', maxlength: '8' },
  { code: 'BJ', label: 'Benin', phone: '229', maxlength: '8' },
  { code: 'BL', label: 'Saint Barthélemy', phone: '590', maxlength: '9' },
  { code: 'BM', label: 'Bermuda', phone: '1-441', maxlength: '7' },
  { code: 'BN', label: 'Brunei Darussalam', phone: '673', maxlength: '7' },
  { code: 'BO', label: 'Bolivia', phone: '591', maxlength: '8' },
  { code: 'BQ', label: 'Bonaire', phone: '599', maxlength: '7' },
  { code: 'BR', label: 'Brazil', phone: '55', maxlength: '11' },
  { code: 'BS', label: 'Bahamas', phone: '1-242', maxlength: '7' },
  { code: 'BT', label: 'Bhutan', phone: '975', maxlength: '8' },
  { code: 'BV', label: 'Bouvet Island', phone: '', maxlength: '' },
  { code: 'BW', label: 'Botswana', phone: '267', maxlength: '8' },
  { code: 'BY', label: 'Belarus', phone: '375', maxlength: '9' },
  { code: 'BZ', label: 'Belize', phone: '501', maxlength: '7' },
  { code: 'CA', label: 'Canada', phone: '1', maxlength: '11' },
  { code: 'CC', label: 'Cocos Islands', phone: '61', maxlength: '9' },
  {
    code: 'CD',
    label: 'Democratic Republic of the Congo',
    phone: '243',
    maxlength: '9'
  },
  {
    code: 'CF',
    label: 'Central African Republic',
    phone: '236',
    maxlength: '8'
  },
  { code: 'CG', label: 'Republic of the Congo', phone: '242', maxlength: '9' },
  { code: 'CH', label: 'Switzerland', phone: '41', maxlength: '9' },
  { code: 'CI', label: 'Ivory Coast', phone: '225', maxlength: '8' },
  { code: 'CK', label: 'Cook Islands', phone: '682', maxlength: '5' },
  { code: 'CL', label: 'Chile', phone: '56', maxlength: '9' },
  { code: 'CM', label: 'Cameroon', phone: '237', maxlength: '8' },
  { code: 'CN', label: 'China', phone: '86', maxlength: '13' },
  { code: 'CO', label: 'Colombia', phone: '57', maxlength: '10' },
  { code: 'CR', label: 'Costa Rica', phone: '506', maxlength: '8' },
  { code: 'CU', label: 'Cuba', phone: '53', maxlength: '10' },
  { code: 'CV', label: 'Cape Verde', phone: '238', maxlength: '7' },
  { code: 'CW', label: 'Curaçao', phone: '599', maxlength: '7' },
  { code: 'CX', label: 'Christmas Island', phone: '61', maxlength: '9' },
  { code: 'CY', label: 'Cyprus', phone: '357', maxlength: '9' },
  { code: 'CZ', label: 'Czech Republic', phone: '420', maxlength: '9' },
  { code: 'DE', label: 'Germany', phone: '49', maxlength: '12' },
  { code: 'DJ', label: 'Djibouti', phone: '253', maxlength: '8' },
  { code: 'DK', label: 'Denmark', phone: '45', maxlength: '8' },
  { code: 'DM', label: 'Dominica', phone: '1-767', maxlength: '11' },
  { code: 'DO', label: 'Dominican Republic', phone: '1-809', maxlength: '11' },
  { code: 'DZ', label: 'Algeria', phone: '213', maxlength: '9' },
  { code: 'EC', label: 'Ecuador', phone: '593', maxlength: '9' },
  { code: 'EE', label: 'Estonia', phone: '372', maxlength: '8' },
  { code: 'EG', label: 'Egypt', phone: '20', maxlength: '10' },
  { code: 'EH', label: 'Western Sahara', phone: '212', maxlength: '9' },
  { code: 'ER', label: 'Eritrea', phone: '291', maxlength: '7' },
  { code: 'ES', label: 'Spain', phone: '34', maxlength: '9' },
  { code: 'ET', label: 'Ethiopia', phone: '251', maxlength: '9' },
  { code: 'FI', label: 'Finland', phone: '358', maxlength: '10' },
  { code: 'FJ', label: 'Fiji', phone: '679', maxlength: '7' },
  { code: 'FK', label: 'Falkland Islands', phone: '500', maxlength: '5' },
  { code: 'FM', label: 'Micronesia', phone: '691', maxlength: '7' },
  { code: 'FO', label: 'Faroe Islands', phone: '298', maxlength: '6' },
  { code: 'FR', label: 'France', phone: '33', maxlength: '10' },
  { code: 'GA', label: 'Gabon', phone: '241', maxlength: '8' },
  { code: 'GB', label: 'United Kingdom', phone: '44', maxlength: '11' },
  { code: 'GD', label: 'Grenada', phone: '1-473', maxlength: '11' },
  { code: 'GE', label: 'Georgia', phone: '995', maxlength: '9' },
  { code: 'GF', label: 'French Guiana', phone: '594', maxlength: '9' },
  { code: 'GG', label: 'Guernsey', phone: '44', maxlength: '10' },
  { code: 'GH', label: 'Ghana', phone: '233', maxlength: '9' },
  { code: 'GI', label: 'Gibraltar', phone: '350', maxlength: '8' },
  { code: 'GL', label: 'Greenland', phone: '299', maxlength: '6' },
  { code: 'GM', label: 'Gambia', phone: '220', maxlength: '7' },
  { code: 'GN', label: 'Guinea', phone: '224', maxlength: '8' },
  { code: 'GP', label: 'Guadeloupe', phone: '590', maxlength: '9' },
  { code: 'GQ', label: 'Equatorial Guinea', phone: '240', maxlength: '8' },
  { code: 'GR', label: 'Greece', phone: '30', maxlength: '10' },
  {
    code: 'GS',
    label: 'South Georgia and the South Sandwich Islands',
    phone: '',
    maxlength: ''
  },
  { code: 'GT', label: 'Guatemala', phone: '502', maxlength: '8' },
  { code: 'GU', label: 'Guam', phone: '1-671', maxlength: '11' },
  { code: 'GW', label: 'Guinea-Bissau', phone: '245', maxlength: '7' },
  { code: 'GY', label: 'Guyana', phone: '592', maxlength: '7' },
  { code: 'HK', label: 'Hong Kong', phone: '852', maxlength: '8' },
  {
    code: 'HM',
    label: 'Heard Island and McDonald Islands',
    phone: '',
    maxlength: ''
  },
  { code: 'HN', label: 'Honduras', phone: '504', maxlength: '8' },
  { code: 'HR', label: 'Croatia', phone: '385', maxlength: '9' },
  { code: 'HT', label: 'Haiti', phone: '509', maxlength: '8' },
  { code: 'HU', label: 'Hungary', phone: '36', maxlength: '9' },
  { code: 'ID', label: 'Indonesia', phone: '62', maxlength: '11' },
  { code: 'IE', label: 'Ireland', phone: '353', maxlength: '10' },
  { code: 'IL', label: 'Israel', phone: '972', maxlength: '9' },
  { code: 'IM', label: 'Isle of Man', phone: '44', maxlength: '10' },
  { code: 'IN', label: 'India', phone: '91', maxlength: '10' },
  {
    code: 'IO',
    label: 'British Indian Ocean Territory',
    phone: '246',
    maxlength: '7'
  },
  { code: 'IQ', label: 'Iraq', phone: '964', maxlength: '10' },
  { code: 'IR', label: 'Iran', phone: '98', maxlength: '11' },
  { code: 'IS', label: 'Iceland', phone: '354', maxlength: '7' },
  { code: 'IT', label: 'Italy', phone: '39', maxlength: '11' },
  { code: 'JE', label: 'Jersey', phone: '44', maxlength: '10' },
  { code: 'JM', label: 'Jamaica', phone: '1-876', maxlength: '11' },
  { code: 'JO', label: 'Jordan', phone: '962', maxlength: '9' },
  { code: 'JP', label: 'Japan', phone: '81', maxlength: '11' },
  { code: 'KE', label: 'Kenya', phone: '254', maxlength: '10' },
  { code: 'KG', label: 'Kyrgyzstan', phone: '996', maxlength: '9' },
  { code: 'KH', label: 'Cambodia', phone: '855', maxlength: '9' },
  { code: 'KI', label: 'Kiribati', phone: '686', maxlength: '5' },
  { code: 'KM', label: 'Comoros', phone: '269', maxlength: '7' },
  {
    code: 'KN',
    label: 'Saint Kitts and Nevis',
    phone: '1-869',
    maxlength: '11'
  },
  { code: 'KP', label: 'North Korea', phone: '850', maxlength: '10' },
  { code: 'KR', label: 'South Korea', phone: '82', maxlength: '10' },
  { code: 'KW', label: 'Kuwait', phone: '965', maxlength: '8' },
  { code: 'KY', label: 'Cayman Islands', phone: '1-345', maxlength: '11' },
  { code: 'KZ', label: 'Kazakhstan', phone: '7', maxlength: '11' },
  { code: 'LA', label: 'Laos', phone: '856', maxlength: '8' },
  { code: 'LB', label: 'Lebanon', phone: '961', maxlength: '8' },
  { code: 'LC', label: 'Saint Lucia', phone: '1-758', maxlength: '11' },
  { code: 'LI', label: 'Liechtenstein', phone: '423', maxlength: '9' },
  { code: 'LK', label: 'Sri Lanka', phone: '94', maxlength: '10' },
  { code: 'LR', label: 'Liberia', phone: '231', maxlength: '7' },
  { code: 'LS', label: 'Lesotho', phone: '266', maxlength: '8' },
  { code: 'LT', label: 'Lithuania', phone: '370', maxlength: '8' },
  { code: 'LU', label: 'Luxembourg', phone: '352', maxlength: '9' },
  { code: 'LV', label: 'Latvia', phone: '371', maxlength: '8' },
  { code: 'LY', label: 'Libya', phone: '218', maxlength: '9' },
  { code: 'MA', label: 'Morocco', phone: '212', maxlength: '9' },
  { code: 'MC', label: 'Monaco', phone: '377', maxlength: '9' },
  { code: 'MD', label: 'Moldova', phone: '373', maxlength: '8' },
  { code: 'ME', label: 'Montenegro', phone: '382', maxlength: '8' },
  { code: 'MF', label: 'Saint Martin', phone: '590', maxlength: '9' },
  { code: 'MG', label: 'Madagascar', phone: '261', maxlength: '9' },
  { code: 'MH', label: 'Marshall Islands', phone: '692', maxlength: '7' },
  { code: 'MK', label: 'North Macedonia', phone: '389', maxlength: '8' },
  { code: 'ML', label: 'Mali', phone: '223', maxlength: '8' },
  { code: 'MM', label: 'Myanmar', phone: '95', maxlength: '9' },
  { code: 'MN', label: 'Mongolia', phone: '976', maxlength: '8' },
  { code: 'MO', label: 'Macao', phone: '853', maxlength: '8' },
  {
    code: 'MP',
    label: 'Northern Mariana Islands',
    phone: '1-670',
    maxlength: '11'
  },
  { code: 'MQ', label: 'Martinique', phone: '596', maxlength: '9' },
  { code: 'MR', label: 'Mauritania', phone: '222', maxlength: '8' },
  { code: 'MS', label: 'Montserrat', phone: '1-664', maxlength: '11' },
  { code: 'MT', label: 'Malta', phone: '356', maxlength: '8' },
  { code: 'MU', label: 'Mauritius', phone: '230', maxlength: '7' },
  { code: 'MV', label: 'Maldives', phone: '960', maxlength: '7' },
  { code: 'MW', label: 'Malawi', phone: '265', maxlength: '9' },
  { code: 'MX', label: 'Mexico', phone: '52', maxlength: '13' },
  { code: 'MY', label: 'Malaysia', phone: '60', maxlength: '10' },
  { code: 'MZ', label: 'Mozambique', phone: '258', maxlength: '9' },
  { code: 'NA', label: 'Namibia', phone: '264', maxlength: '9' },
  { code: 'NC', label: 'New Caledonia', phone: '687', maxlength: '6' },
  { code: 'NE', label: 'Niger', phone: '227', maxlength: '8' },
  { code: 'NF', label: 'Norfolk Island', phone: '672', maxlength: '6' },
  { code: 'NG', label: 'Nigeria', phone: '234', maxlength: '10' },
  { code: 'NI', label: 'Nicaragua', phone: '505', maxlength: '8' },
  { code: 'NL', label: 'Netherlands', phone: '31', maxlength: '10' },
  { code: 'NO', label: 'Norway', phone: '47', maxlength: '8' },
  { code: 'NP', label: 'Nepal', phone: '977', maxlength: '10' },
  { code: 'NR', label: 'Nauru', phone: '674', maxlength: '7' },
  { code: 'NU', label: 'Niue', phone: '683', maxlength: '4' },
  { code: 'NZ', label: 'New Zealand', phone: '64', maxlength: '10' },
  { code: 'OM', label: 'Oman', phone: '968', maxlength: '8' },
  { code: 'PA', label: 'Panama', phone: '507', maxlength: '8' },
  { code: 'PE', label: 'Peru', phone: '51', maxlength: '9' },
  { code: 'PF', label: 'French Polynesia', phone: '689', maxlength: '6' },
  { code: 'PG', label: 'Papua New Guinea', phone: '675', maxlength: '7' },
  { code: 'PH', label: 'Philippines', phone: '63', maxlength: '10' },
  { code: 'PK', label: 'Pakistan', phone: '92', maxlength: '10' },
  { code: 'PL', label: 'Poland', phone: '48', maxlength: '9' },
  {
    code: 'PM',
    label: 'Saint Pierre and Miquelon',
    phone: '508',
    maxlength: '6'
  },
  { code: 'PN', label: 'Pitcairn', phone: '870', maxlength: '15' },
  { code: 'PR', label: 'Puerto Rico', phone: '1', maxlength: '11' },
  { code: 'PS', label: 'Palestinian Territory', phone: '970', maxlength: '10' },
  { code: 'PT', label: 'Portugal', phone: '351', maxlength: '9' },
  { code: 'PW', label: 'Palau', phone: '680', maxlength: '7' },
  { code: 'PY', label: 'Paraguay', phone: '595', maxlength: '9' },
  { code: 'QA', label: 'Qatar', phone: '974', maxlength: '8' },
  { code: 'RE', label: 'Réunion', phone: '262', maxlength: '9' },
  { code: 'RO', label: 'Romania', phone: '40', maxlength: '10' },
  { code: 'RS', label: 'Serbia', phone: '381', maxlength: '10' },
  { code: 'RU', label: 'Russia', phone: '7', maxlength: '11' },
  { code: 'RW', label: 'Rwanda', phone: '250', maxlength: '9' },
  { code: 'SA', label: 'Saudi Arabia', phone: '966', maxlength: '9' },
  { code: 'SB', label: 'Solomon Islands', phone: '677', maxlength: '5' },
  { code: 'SC', label: 'Seychelles', phone: '248', maxlength: '7' },
  { code: 'SD', label: 'Sudan', phone: '249', maxlength: '9' },
  { code: 'SE', label: 'Sweden', phone: '46', maxlength: '11' },
  { code: 'SG', label: 'Singapore', phone: '65', maxlength: '8' },
  { code: 'SH', label: 'Saint Helena', phone: '290', maxlength: '4' },
  { code: 'SI', label: 'Slovenia', phone: '386', maxlength: '8' },
  { code: 'SJ', label: 'Svalbard and Jan Mayen', phone: '47', maxlength: '8' },
  { code: 'SK', label: 'Slovakia', phone: '421', maxlength: '9' },
  { code: 'SL', label: 'Sierra Leone', phone: '232', maxlength: '8' },
  { code: 'SM', label: 'San Marino', phone: '378', maxlength: '10' },
  { code: 'SN', label: 'Senegal', phone: '221', maxlength: '9' },
  { code: 'SO', label: 'Somalia', phone: '252', maxlength: '7' },
  { code: 'SR', label: 'Suriname', phone: '597', maxlength: '7' },
  { code: 'SS', label: 'South Sudan', phone: '211', maxlength: '9' },
  { code: 'ST', label: 'Sao Tome and Principe', phone: '239', maxlength: '7' },
  { code: 'SV', label: 'El Salvador', phone: '503', maxlength: '8' },
  { code: 'SX', label: 'Sint Maarten', phone: '1-721', maxlength: '11' },
  { code: 'SY', label: 'Syria', phone: '963', maxlength: '9' },
  { code: 'SZ', label: 'Eswatini', phone: '268', maxlength: '8' },
  {
    code: 'TC',
    label: 'Turks and Caicos Islands',
    phone: '1-649',
    maxlength: '11'
  },
  { code: 'TD', label: 'Chad', phone: '235', maxlength: '8' },
  {
    code: 'TF',
    label: 'French Southern Territories',
    phone: '',
    maxlength: ''
  },
  { code: 'TG', label: 'Togo', phone: '228', maxlength: '8' },
  { code: 'TH', label: 'Thailand', phone: '66', maxlength: '10' },
  { code: 'TJ', label: 'Tajikistan', phone: '992', maxlength: '9' },
  { code: 'TK', label: 'Tokelau', phone: '690', maxlength: '4' },
  { code: 'TL', label: 'East Timor', phone: '670', maxlength: '7' },
  { code: 'TM', label: 'Turkmenistan', phone: '993', maxlength: '8' },
  { code: 'TN', label: 'Tunisia', phone: '216', maxlength: '8' },
  { code: 'TO', label: 'Tonga', phone: '676', maxlength: '5' },
  { code: 'TR', label: 'Turkey', phone: '90', maxlength: '11' },
  { code: 'TT', label: 'Trinidad and Tobago', phone: '1-868', maxlength: '11' },
  { code: 'TV', label: 'Tuvalu', phone: '688', maxlength: '5' },
  { code: 'TW', label: 'Taiwan', phone: '886', maxlength: '10' },
  { code: 'TZ', label: 'Tanzania', phone: '255', maxlength: '10' },
  { code: 'UA', label: 'Ukraine', phone: '380', maxlength: '12' },
  { code: 'UG', label: 'Uganda', phone: '256', maxlength: '9' },
  {
    code: 'UM',
    label: 'United States Minor Outlying Islands',
    phone: '',
    maxlength: ''
  },
  { code: 'US', label: 'United States', phone: '1', maxlength: '11' },
  { code: 'UY', label: 'Uruguay', phone: '598', maxlength: '8' },
  { code: 'UZ', label: 'Uzbekistan', phone: '998', maxlength: '9' },
  { code: 'VA', label: 'Vatican', phone: '379', maxlength: '10' },
  {
    code: 'VC',
    label: 'Saint Vincent and the Grenadines',
    phone: '1-784',
    maxlength: '11'
  },
  { code: 'VE', label: 'Venezuela', phone: '58', maxlength: '10' },
  {
    code: 'VG',
    label: 'British Virgin Islands',
    phone: '1-284',
    maxlength: '11'
  },
  { code: 'VI', label: 'U.S. Virgin Islands', phone: '1-340', maxlength: '11' },
  { code: 'VN', label: 'Vietnam', phone: '84', maxlength: '10' },
  { code: 'VU', label: 'Vanuatu', phone: '678', maxlength: '5' },
  { code: 'WF', label: 'Wallis and Futuna', phone: '681', maxlength: '6' },
  { code: 'WS', label: 'Samoa', phone: '685', maxlength: '5' },
  { code: 'YE', label: 'Yemen', phone: '967', maxlength: '9' },
  { code: 'YT', label: 'Mayotte', phone: '262', maxlength: '9' },
  { code: 'ZA', label: 'South Africa', phone: '27', maxlength: '11' },
  { code: 'ZM', label: 'Zambia', phone: '260', maxlength: '9' },
  { code: 'ZW', label: 'Zimbabwe', phone: '263', maxlength: '9' }
]

function countryToFlag(isoCode) {
  return typeof String.fromCodePoint !== 'undefined'
    ? isoCode
      .toUpperCase()
      .replace(/./g, char =>
        String.fromCodePoint(char.charCodeAt(0) + 127397)
      )
    : isoCode
}

const GetMobileNum = props => {
  const ref0 = useRef()
  const mobileInputRef = useRef(null);

  const [defaultCode, setDefaultCode] = useState({
    code: 'AE',
    label: 'United Arab Emirates',
    phone: '971',
    maxlength: '9'
  })

  const [countryCode, setCountryCode] = useState({
    code: 'AE',
    label: 'United Arab Emirates',
    phone: '971',
    maxlength: '9'
  })

  useEffect(() => {
    if (mobileInputRef.current) {
      mobileInputRef.current.focus();
    }
  }, [defaultCode]); // refocus when country code changes


  return (
    <Box className='signin-mobile'>
      <Grid
        container
        spacing={0}
        direction='column'
        alignItems='flex-start'
        justifyContent='center'
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          style={{ width: "100%" }}
        >
          <Typography variant='body2' style={{
            textAlign: "start"
          }}>
            Enter your phone number (required)
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          style={{ width: '100%', marginTop: '16px' }}
        >
          <Box
            style={{ display: 'flex', flexDirection: 'row', border: 'none' }}
          >
            <Autocomplete
              sx={{
                width: "40%",
                "& .MuiAutocomplete-option": {
                  // backgroundColor: "green", // optional
                },
                "& .MuiAutocomplete-paper": {
                  width: 280,
                },
                "& .MuiAutocomplete-inputRoot": {
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                },
                "& .MuiAutocomplete-input": {
                  // fontSize: "14px",
                  // padding: "6px",
                },
              }}
              defaultValue={defaultCode}
              name="countryCode"
              ref={ref0}
              onChange={(e, newValue) => {
                if (newValue) {
                  props.handleInput(ref0.current?.getAttribute("name"), newValue.phone);
                  setDefaultCode(newValue);
                  props.setPrintMsg(null);
                }
              }}
              disableClearable
              options={countries}
              autoHighlight
              getOptionLabel={(option) =>
                typeof option === "string" ? option : `${option.code}+${option.phone}`
              }
              filterOptions={(options, { inputValue }) =>
                options.filter(
                  (option) =>
                    option.label.toLowerCase().includes(inputValue.toLowerCase()) ||
                    option.code.toLowerCase().includes(inputValue.toLowerCase()) ||
                    option.phone.includes(inputValue)
                )
              }
              renderOption={(props, option) => (
                <li {...props}>
                  <span>{countryToFlag(option.code)}</span>&nbsp;
                  {/* {option.label} ({option.code}) +{option.phone} */}
                  +{option.phone}
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder="Country Code"
                  onClick={(params) => (params.target.value = "")}
                  variant="outlined"
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: "new-password", // disable autocomplete and autofill
                  }}
                />
              )}
            />

            <TextField
              autoFocus
              style={{ width: '100%' }}
              id='standard-basic'
              inputRef={mobileInputRef}
              // label="Standard"
              type='tel'
              variant='outlined'
              pattern='[0-9]'
              className='mobileNum'
              size='small'
              // inputProps={{ maxLength: countryCode?.maxLength }}
              // maxLength={defaultCode ? defaultCode.maxlength : undefined}
              value={props.apiData.mobileNumber}
              name='mobileNumber'
              required
              onChange={e => props.handleInput(e)}
              onInput={e =>
              (e.target.value = e.target.value
                .replace(/[^0-9.]/g, '')
                .replace(/(\..*)\./g, '$1'))
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <PhoneAndroidIcon sx={{ color: '#66c9bb ' }} />
                  </InputAdornment>
                )
              }}
              inputProps={{
                maxLength: defaultCode ? defaultCode.maxlength : undefined
              }}
            />
          </Box>
          <Typography
            variant='body2'
            sx={{
              textAlign: 'center',
              color: props.error === null ? 'white' : 'red'
            }}
          >
            {'please fill the number'}
          </Typography>
          {props.printMsg !== null ? (
            <Typography
              variant='body2'
              sx={{
                textAlign: 'center',
                color: 'red'
              }}
            >
              {props.printMsg}
            </Typography>
          ) : (
            ''
          )}
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          style={{ width: '100%', marginTop: '10px' }}
        >
          {!props.loading ? (
            <Box style={{ textAlign: 'center' }}>
              <Button
                // style={{
                //   width: "100%",
                //   borderRadius: "100px",
                //   backgroundColor: "#66c9bb ",
                //   color: "white",
                //   padding: "12px",
                // }}
                className='btn-1 text-white'
                variant='contained'
                onClick={props.handleNextButton}
                fullWidth
              >
                Continue
              </Button>
              {/* <Button
                className="btn-1 text-white"
                style={{ margin: "0px 0px 0px 8px" }}
                variant="contained"
                onClick={props.handleCancel}
              >
                Cancel
              </Button> */}
            </Box>
          ) : (
            <Box style={{ textAlign: 'center' }}>
              <Button
                variant='contained'
                className='btn-1 text-white'
                disabled
                fullWidth
              >
                <CircularProgress size={24} sx={{ color: 'white' }} />
              </Button>
            </Box>
          )}
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          style={{ width: '100%', marginTop: '10px' }}
        >
          <Typography variant='subtitle1'></Typography>
          {/* <Link href="#"> or connect using social network</Link> */}
        </Grid>
      </Grid>
    </Box>
  )
}

const SignIn = ({
  setOtpLoading,
  otpLoading,
  printMsg,
  setPrintMsg,
  setOpenReg,
  setIsSignUp,
  viewStatus,
  setViewStatus,
  refTocken
}) => {
  const dispatch = useDispatch()

  const { data: session, status, user, customuser } = useSession()
  const { userDetail, accessTocken } = useSelector(state => state.user)

  const router = useRouter()

  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const [apiData, setApiData] = useState({
    mobileNumber: '',
    countryCode: '+971',
    otp: '',
    password: '',
    email: '',
    firstName: '',
    lastName: '',
    newPassword: '',
    passenger_id: '',
    userId: ''
  })

  const [verifyPhoneResponse, setVerifyPhoneResponse] = useState('')
  const getLatestPath = sessionStorage.getItem('bookingPath')

  const setCookie = (name, value, minutes) => {
    const date = new Date()
    date.setTime(date.getTime() + minutes * 60 * 1000)
    const expires = `expires=${date.toUTCString()}`
    document.cookie = `${name}=${value};${expires};path=/`
  }

  useEffect(() => {
    setCookie('apiToken', accessTocken?.accessToken, 1)
  }, [accessTocken])

  const handleInputChange = (e, otpField) => {
    if (otpField === 'otp') {
      setApiData({ ...apiData, otp: e })
    } else if (e === 'countryCode') {
      setApiData({ ...apiData, [e]: otpField ? `+${otpField}` : null })
    } else {
      let { name, value } = e.target
      setApiData({ ...apiData, [name]: value })
    }
    setPrintMsg(null);
  }

  const handleMobileNext = async () => {
    localStorage.setItem('isSignInUpCompleted', false)
    // Dispatch custom event so other components (like header) can listen
    window.dispatchEvent(new Event('isSignInUpCompletedChange'))
    const getCookie = name => {
      const cookieValue = document.cookie
        .split('; ')
        .find(row => row.startsWith(`${name}=`))

      if (cookieValue) {
        return cookieValue.split('=')[1]
      }

      return null
    }

    // Usage
    const apiToken = getCookie('apiToken')

    if (apiData.mobileNumber === '') {
      setPrintMsg('Please enter phoneNumber')
    } else {
      const phonenoFormat = /^[0-9\b]+$/
      if (phonenoFormat.test(apiData.mobileNumber)) {
        if (apiData.mobileNumber.length < 7) {
          setPrintMsg('phoneNumber must be min 7 or max 10')
        } else if (apiData.mobileNumber.length > 13) {
          setPrintMsg('phoneNumber must be min 7 or max 10')
        } else if (!apiData.countryCode) {
          setPrintMsg('Please select country code');
        }
        else {
          setError(null)
          setLoading(true)
          const response = await signIn('credentials', {
            countryCode: apiData.countryCode,
            loginType: 'verifyPhone',
            mobile: apiData.mobileNumber,
            deviceType: 'android',
            deviceToken: 'abc456xyz',
            deviceId: '12',
            socialEmail:
              JSON.parse(sessionStorage.getItem('userEmail')) !== '' &&
                JSON.parse(sessionStorage.getItem('userEmail')) !== null &&
                JSON.parse(sessionStorage.getItem('userEmail')) !== undefined
                ? JSON.parse(sessionStorage.getItem('userEmail'))
                : '',
            refTocken: session?.customuser?.accessToken
              ? session?.customuser?.accessToken
              : apiToken,
            accessToken: sessionStorage.getItem("accessToken") || "",
            redirect: false // Disable automatic redirect
          }).then(res => {
            if (res.ok) {
              setViewStatus(false)
            } else {
              dispatch(getAccessToken({}))
            }
            setVerifyPhoneResponse(res)
          })
        }
      } else {
        setPrintMsg('Please enter valid phoneNumber only')
      }
    }
  }

  useEffect(() => {
    // if (session?.customuser.status === 1 || session?.customuser.status === 2) {
    if (
      (session?.customuser?.status === 1 &&
        session?.customuser?.handledStatus === 1) ||
      (session?.customuser?.status === 2 &&
        session?.customuser?.handledStatus === 2)
    ) {

      setApiData({
        ...apiData,
        userId: session?.customuser?.responseData?.userId
      })
      // if (session?.customuser.type === 'verifyOtp') {
      //
      //   dispatch(
      //     getProfile({
      //       tourism_id: session?.customuser?.responseData.userId,
      //     })
      //   );
      // }
    } else if (
      session?.customuser.status === 2 &&
      session?.customuser.handledStatus === 4
    ) {
      setPrintMsg('Phone number already exists!')
      setLoading(false)
      setViewStatus(true)
    } else {

      if (session?.accessToken) {
        sessionStorage.setItem("accessToken", session?.accessToken);
      }
      if (session?.refreshToken) {
        sessionStorage.setItem("refreshToken", session?.refreshToken);
      }
    }
  }, [session, viewStatus])

  useEffect(() => {
    if (userDetail !== undefined) {
      // setViewStatus(false);
      // setApiData({
      //   ...apiData,
      //   userId: userDetail.responseData.userId,
      // });
      sessionStorage.setItem(
        'rslkey',
        JSON.stringify(userDetail.responseData._id)
      )
      sessionStorage.setItem(
        'phone',
        JSON.stringify(userDetail.responseData.mobile)
      )
      sessionStorage.setItem(
        'countryCode',
        JSON.stringify(userDetail.responseData.countryCode)
      )
      sessionStorage.setItem(
        'userName',
        JSON.stringify(userDetail.responseData.name)
      )
      sessionStorage.setItem(
        'userEmail',
        JSON.stringify(userDetail.responseData.email)
      )
    }
  }, [userDetail])

  const handleOtpSubmit = async wholeOtp => {
    const getCookie = name => {
      const cookieValue = document.cookie
        .split('; ')
        .find(row => row.startsWith(`${name}=`))

      if (cookieValue) {
        return cookieValue.split('=')[1]
      }

      return null
    }

    // Usage
    const apiToken = getCookie('apiToken')

    if (wholeOtp === '') {
      // setPrintMsg('Please enter a valid otp');
    } else if (wholeOtp.length !== 4) {
      // setPrintMsg('Please enter 4 digits otp');
    } else {
      await signIn('credentials', {
        loginType: 'verifyOtp',
        userId: apiData.userId,
        otp: wholeOtp,
        countryCode: apiData.countryCode,
        mobile: apiData.mobileNumber,
        refTocken: session?.customuser?.accessToken
          ? session?.customuser?.accessToken
          : apiToken,
        accessToken: sessionStorage.getItem("accessToken") || "",
        redirect: false // Disable automatic redirect
      }).then(res => {
        if (res.ok) {
          // setViewStatus(true);
          // setOpenReg(false);
          // setIsSignUp(false);
          if (res.ok) {
            setViewStatus(false)
            // localStorage.setItem('isSignInUpCompleted', true)
            // Dispatch custom event so other components (like header) can listen
            window.dispatchEvent(new Event('isSignInUpCompletedChange'))
          } else {
            dispatch(getAccessToken({}))
          }
        }
        setVerifyPhoneResponse(res)
      })
    }
  }

  function handleCancel() {
    router.push('/')
  }

  useEffect(() => {
    if (accessTocken !== undefined) {
      if (accessTocken?.accessToken !== '') {
        handleMobileNext()
      }
    }
  }, [accessTocken])

  return (
    <>
      <form className='sign-in-form row'>
        <div className='sign-in-header col-12 text-center'>
          {/* <div className="signin-right-text">
            <h2>
              Hello
              <span
                className="header-span"
                style={{ color: "rgba(109, 200, 191, 1)" }}
              >
                Again!
              </span>
            </h2>
            <p className="text-black">
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem
              accusantium doloremque laudantium,
            </p>
          </div> */}
          <div className='d-flex' style={{ justifyContent: 'center' }}>
            {viewStatus ? (
              <GetMobileNum
                apiData={apiData}
                handleNextButton={handleMobileNext}
                handleInput={handleInputChange}
                error={error}
                loading={loading}
                printMsg={printMsg}
                handleCancel={handleCancel}
                setPrintMsg={setPrintMsg}
                setApiData={setApiData}
              // handleCountrySelect={handleCountrySelect}
              />
            ) : // <GetOtp
              //   apiData={apiData}
              //   handleNextButton={handleOtpSubmit}
              //   handleInput={handleInputChange}
              //   handleResendOtp={handleResendOtp}
              //   error={error}
              //   loading={loading}
              //   printMsg={printMsg}
              //   setOpenReg={setOpenReg}

              // />
              otpLoading ? (
                <div>
                  <CircularProgress sx={{ color: '#66c9bb' }} />
                </div>
              ) : (
                <OTPInputGroup
                  printMsg={printMsg}
                  handleNextButton={handleOtpSubmit}
                  setOtpLoading={setOtpLoading}
                  otpLoading={otpLoading}
                  setPrintMsg={setPrintMsg}
                />
              )}
          </div>
        </div>
      </form>
    </>
  )
}

export default SignIn
